type StoreLink = {
	code: number;
	link: string;
};

export const MockStoreLinks: StoreLink[] = [
	{ code: 22, link: 'moskva-klimovsk' },
	{ code: 56, link: 'moskva-yudino' },
	{ code: 35, link: 'moskva-zelenograd' },
	{ code: 26, link: 'moskva-ryazanskiy-prospekt' },
	{ code: 49, link: 'moskva-lyubercy' },
	{ code: 28, link: 'moskva-noginsk' },
	{ code: 153, link: 'moskva-zhukovskiy' },
	{ code: 143, link: 'moskva-varshavskoe-shosse' },
	{ code: 122, link: 'moskva-istra' },
	{ code: 2, link: 'moskva-mytishchi' },
	{ code: 3, link: 'moskva-krasnogorsk' },
	{ code: 4, link: 'moskva-altufevo' },
	{ code: 114, link: 'moskva-domodedovo' },
	{ code: 169, link: 'moskva-vyhino' },
	{ code: 5, link: 'moskva-himki' },
	{ code: 6, link: 'moskva-sokolniki' },
	{ code: 117, link: 'moskva-zil' },
	{ code: 40, link: 'moskva-sholohovo' },
	{ code: 51, link: 'moskva-kievskoe-shosse' },
	{ code: 20, link: 'moskva-lefortovo' },
	{ code: 86, link: 'moskva-troick' },
	{ code: 32, link: 'moskva-novaya-riga' },
	{ code: 43, link: 'moskva-kashirskoe-shosse' },
	{ code: 65, link: 'moskva-pushkino' },
	{ code: 11, link: 'sankt-peterburg-ispytateley' },
	{ code: 134, link: 'sankt-peterburg-parashyutnaya' },
	{ code: 135, link: 'sankt-peterburg-moskovskoe-shosse' },
	{ code: 136, link: 'sankt-peterburg-petergofskoe-shosse' },
	{ code: 137, link: 'sankt-peterburg-tallinskoe-shosse' },
	{ code: 138, link: 'sankt-peterburg-uralskaya' },
	{ code: 41, link: 'sankt-peterburg-bugry' },
	{ code: 140, link: 'sankt-peterburg-vyborgskoe-shosse' },
	{ code: 42, link: 'sankt-peterburg-partizana-germana' },
	{ code: 141, link: 'sankt-peterburg-rustaveli' },
	{ code: 10, link: 'sankt-peterburg-kollontay' },
	{ code: 83, link: 'arhangelsk' },
	{ code: 89, link: 'barnaul-pravoberezhnyy' },
	{ code: 36, link: 'barnaul' },
	{ code: 90, link: 'belgorod' },
	{ code: 75, link: 'vladivostok' },
	{ code: 150, link: 'vladikavkaz' },
	{ code: 24, link: 'volgograd' },
	{ code: 70, link: 'volzhskiy' },
	{ code: 111, link: 'voronezh-otradnoe' },
	{ code: 21, link: 'voronezh' },
	{ code: 25, link: 'ekaterinburg' },
	{ code: 53, link: 'ekaterinburg-metallurgov' },
	{ code: 93, link: 'ivanovo' },
	{ code: 115, link: 'izhevsk' },
	{ code: 68, link: 'irkutsk' },
	{ code: 46, link: 'kazan-solnechnyy' },
	{ code: 27, link: 'kazan' },
	{ code: 163, link: 'kazan-zalesnyy' },
	{ code: 78, link: 'kaliningrad' },
	{ code: 142, link: 'kaluga' },
	{ code: 55, link: 'kemerovo' },
	{ code: 128, link: 'kemerovo-zavod' },
	{ code: 77, link: 'kirov' },
	{ code: 126, link: 'klin' },
	{ code: 59, link: 'kostroma' },
	{ code: 147, link: 'krasnodar-adygeya' },
	{ code: 8, link: 'krasnodar-sbs' },
	{ code: 92, link: 'krasnodar-zapadnyy-obhod' },
	{ code: 23, link: 'krasnoyarsk-planeta' },
	{ code: 37, link: 'krasnoyarsk-mega' },
	{ code: 82, link: 'krasnoyarsk-kalinina' },
	{ code: 73, link: 'kursk' },
	{ code: 155, link: 'lipetsk' },
	{ code: 39, link: 'naberezhnye-chelny' },
	{ code: 118, link: 'naro-fominsk' },
	{ code: 119, link: 'nizhniy-novgorod' },
	{ code: 129, link: 'novokuznetsk-damba' },
	{ code: 165, link: 'novorossiysk' },
	{ code: 12, link: 'novosibirsk-mega' },
	{ code: 67, link: 'novosibirsk-rodniki' },
	{ code: 124, link: 'novosibirsk-gigant' },
	{ code: 30, link: 'novosibirsk-fabrichnyy' },
	{ code: 88, link: 'omsk-amurskaya' },
	{ code: 16, link: 'omsk-mega' },
	{ code: 74, link: 'orenburg' },
	{ code: 48, link: 'penza' },
	{ code: 109, link: 'perm' },
	{ code: 79, link: 'petrozavodsk' },
	{ code: 156, link: 'pskov' },
	{ code: 14, link: 'rostov-orbitalnaya' },
	{ code: 7, link: 'rostov-mega' },
	{ code: 94, link: 'rostov-dovatora' },
	{ code: 19, link: 'ryazan' },
	{ code: 34, link: 'samara-yuzhnoe-shosse' },
	{ code: 13, link: 'samara-mega' },
	{ code: 9, link: 'samara-dybenko' },
	{ code: 127, link: 'saransk' },
	{ code: 57, link: 'saratov' },
	{ code: 181, link: 'smolensk' },
	{ code: 69, link: 'stavropol' },
	{ code: 87, link: 'surgut' },
	{ code: 18, link: 'tver' },
	{ code: 80, link: 'tolyatti' },
	{ code: 47, link: 'tula' },
	{ code: 110, link: 'tyumen-tobolskiy' },
	{ code: 31, link: 'tyumen' },
	{ code: 71, link: 'ulyanovsk' },
	{ code: 33, link: 'ufa-planeta' },
	{ code: 17, link: 'ufa-mega' },
	{ code: 123, link: 'habarovsk-sever' },
	{ code: 81, link: 'habarovsk' },
	{ code: 38, link: 'chelyabinsk' },
	{ code: 91, link: 'cherepovec' },
	{ code: 58, link: 'yaroslavl-bor' },
	{ code: 52, link: 'yaroslavl-vernisazh' },
	{ code: 44, link: 'novokuznetsk' },
	{ code: 131, link: 'magnitogorsk' },
];
